(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-consultation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const link=event.target.closest('[data-clara-chat]');
  if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  if(window.fonio?.webchat?.open){
    event.preventDefault();
    try{window.fonio.webchat.open()}catch{window.location.assign(link.href)}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-showroom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-clara-showroom]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  if (window.fonio?.webchat?.open) {
    event.preventDefault();
    try { window.fonio.webchat.open(); } catch { window.location.assign(link.href); }
  }
});

  } catch(e) { console.error(e); }
})();
})();
